
import { Component } from "@angular/core";
import { AppConfig } from "../../app.config";
import { Features } from '../../models/features';
@Component({
  selector: "app-unauthorised",
  templateUrl: "./unauthorised.component.html",
  styleUrls: ["./unauthorised.component.scss"]
})
export class UnauthorisedComponent {
  showHeader: boolean;

  constructor(
    private appConfig: AppConfig
  ) {
    this.showHeader = (this.appConfig.getSection(Features.PUBLIC_HEADER) && !!this.appConfig.getSection(Features.PUBLIC_HEADER).enabled)
      ? this.appConfig.getSection(Features.PUBLIC_HEADER).enabled
      : false;
  }
}
